export function getDisplayPlanName(
  plan: string,
  subscriptionStatus?: string | null,
  email?: string | null
): string {
  if (plan === "agent") {
    if (email?.toLowerCase().endsWith("@zimamedia.com")) {
      return "Agent";
    }
    return "Agency";
  }
  if (plan === "pro") {
    if (subscriptionStatus === "trialing") return "Trial";
    return "Starter";
  }
  if (plan === "starter") {
    if (subscriptionStatus === "canceled") return "Inactive";
    return "Inactive";
  }
  return plan.charAt(0).toUpperCase() + plan.slice(1);
}
